import ImageCard from "../gallery/imageCard";
import AIImageCaption from "./aiImageCaption";
import AIImageMetadataContent from "./aiImageMetadataContent";
import {ImageCardProps} from "../gallery/types";

const AISearchImageCard = ({ imageSrc, ...props }: ImageCardProps) => {
  return (
    <ImageCard
      {...props}
      imageSrc={imageSrc}
      caption={<AIImageCaption imageSrc={imageSrc} />}
      ImageMetadataComponent={AIImageMetadataContent}
    />
  );
};

export default AISearchImageCard;
